var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Promo',{attrs:{"msg":"PÁGINA NO <br> ENCONTRADA","btn":"IR AL INICIO"},on:{"promoClicked":_vm.goToHome}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }